var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import Session from '../../services/Session';
/**
 *
 */
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    /**
     *
     * @param props
     */
    function Page(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { show: false };
        return _this;
    }
    /**
     *
     */
    Page.prototype.componentDidMount = function () {
        var _this = this;
        this.inAnimationTimeout = setTimeout(function () {
            _this.setState({ show: true });
        }, 1);
    };
    /**
     *
     */
    Page.prototype.componentWillUnmount = function () {
        clearTimeout(this.inAnimationTimeout);
    };
    /**
     *
     * @return {*}
     */
    Page.prototype.render = function () {
        var showClass = classNames({ 'page--show': this.state.show });
        var classes = "page ".concat(this.props.pageName, " ").concat(showClass, " ").concat((!Session.isInitialized || !Session.isLoggedIn || Session.user.requiresOnBoarding) ? '' : 'navbarMargin', " ").concat(this.props.className ? this.props.className : '');
        var fixedStyle = { height: "100vh" };
        if (this.props.style) {
            fixedStyle = Object.assign(fixedStyle, this.props.style);
        }
        return (React.createElement("div", { style: fixedStyle, className: classes }, this.props.children));
    };
    return Page;
}(React.Component));
export default Page;
